var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPropaganda(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.2,112.8c0-15.7,12.7-28.4,28.4-28.4s28.4,12.7,28.4,28.4s-12.7,28.4-28.4,28.4S122.2,128.5,122.2,112.8z M32.5,48.4 L65.1,60L256,0.5l-67.6-0.4L32.5,48.4z M210.4,241.2l-3.6-181.2l-5.4,0.1l3.6,181.2L210.4,241.2z M68.3,150.4l-1.5-98.8l-5.4,0.1 l1.5,98.8L68.3,150.4z M39.6,198L38.8,48.7l-5.4,0l0.8,149.4L39.6,198z M207.7,226.9h-34.9l-9.7-56.2c-2.5-10.9-21.6-24.7-33-24.7 H69.8c-4.2,0-8.3,2.2-10.6,5.8l-23.9,41.8c-3.6,5.8-1.3,13.2,4.4,16.7c5.2,3.3,12.9,1.3,16.7-4.2l20.4-35.4h31.6l-38.9,67.1 c-2.5,4.2-3.7,9-3.7,13.7l59.5,0.6l19.5-35l4.1,25.1c1.6,5.5,6.6,9.3,12.4,9.3h46.5c6.9,0.2,12-5,12.3-11.7 C220.3,233.7,214.3,227.5,207.7,226.9z M128.9,0H79.1l106.3,67.3l39.8-4L128.9,0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropaganda);
export default __webpack_public_path__ + "static/media/propaganda.8adbee3615b5e183d37af7812db3e830.svg";
export { ForwardRef as ReactComponent };